import { Injectable, computed, effect, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly _storageKey = 'emp-admin-dashboard-theme';
  private readonly _theme = signal<'light' | 'dark'>(this.readStoredTheme());

  readonly theme = computed(() => this._theme());

  private readonly _persistThemeEffect = effect(() => {
    const value = this._theme();

    if (!this.canUseStorage()) {
      return;
    }

    localStorage.setItem(this._storageKey, value);
  });

  toggle(): void {
    this._theme.update(value => (value === 'dark' ? 'light' : 'dark'));
  }

  private readStoredTheme(): 'light' | 'dark' {
    if (!this.canUseStorage()) {
      return 'dark';
    }

    const stored = localStorage.getItem(this._storageKey);
    return stored === 'light' || stored === 'dark' ? stored : 'dark';
  }

  private canUseStorage(): boolean {
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
  }
}
